import React from 'react'
const SettingsSection: React.FC = () => {
  return (
    <div className="p-4">
      <p className="text-sm text-casevo-forest">
        Settings panel — admin access only. Configuration options will be added here.
      </p>
    </div>
  )
}
export default SettingsSection
